import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { PAYMENT_CONFIG } from '../config/constants';

interface FormState {
  // Form inputs
  amountUsd: string;
  selectedNetwork: string;
  selectedToken?: string;

  // Form actions
  setAmount: (amount: string) => void;
  setNetwork: (network: string) => void;
  setToken: (token?: string) => void;
  resetForm: () => void;

  // Computed values
  getIsValidAmount: () => boolean;
  getTokensToReceive: (pricePerToken: number) => number;
}

const calculateTokensToReceive = (amount: string, pricePerToken: number): number => {
  if (!amount || isNaN(parseFloat(amount))) return 0;
  const usdAmount = parseFloat(amount);
  if (usdAmount <= 0) return 0;
  return usdAmount / pricePerToken;
};

export const useFormStore = create<FormState>()(
  devtools(
    (set, get) => ({
      // Initial state
      amountUsd: '10',
      selectedNetwork: 'Ethereum',
      selectedToken: undefined,

      // Actions
      setAmount: (amount) => set({ amountUsd: amount }),
      setNetwork: (network) => set({ selectedNetwork: network }),
      setToken: (token) => set({ selectedToken: token }),
      resetForm: () => set({
        amountUsd: '10',
        selectedNetwork: 'Ethereum',
        selectedToken: undefined
      }),

      // Computed values
      getIsValidAmount: () => {
        const amount = get().amountUsd;
        if (!amount || !amount.trim()) return false;
        const numAmount = parseFloat(amount);
        return !isNaN(numAmount) && numAmount >= PAYMENT_CONFIG.MIN_PAYMENT_AMOUNT && numAmount <= PAYMENT_CONFIG.MAX_PAYMENT_AMOUNT;
      },

      getTokensToReceive: (pricePerToken: number) => {
        const { amountUsd } = get();
        return calculateTokensToReceive(amountUsd, pricePerToken);
      },
    }),
    { name: 'form-store' }
  )
);

